import { render } from "./TeacherProctorView.vue?vue&type=template&id=21f92498&scoped=true"
import script from "./TeacherProctorView.vue?vue&type=script&lang=js"
export * from "./TeacherProctorView.vue?vue&type=script&lang=js"

import "./TeacherProctorView.vue?vue&type=style&index=0&id=21f92498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f92498"]])

export default __exports__